import { insuranceNetworkValues, } from "./InsuranceNetworks.js";
import { isTherapeuticMaterialCodeAllowed } from "./materiaux.js";
export const therapeuticChoiceRowOrder = [
    "crown_incisor_canine_first_premolar",
    "crown_second_premolar",
    "crown_molar",
    "tooth_supported_bridge",
    "implant_crown",
];
export const therapeuticChoiceRowLabels = {
    crown_incisor_canine_first_premolar: "Couronne sur Incisive/Canine/1ère PM",
    crown_second_premolar: "Couronne sur 2ème PM",
    crown_molar: "Couronne sur Molaire",
    tooth_supported_bridge: "Bridge dentoporté",
    implant_crown: "Couronne sur Implant",
};
export const therapeuticActKindOrder = [
    "implant",
    "implant_abutment",
    "crown",
    "bridge",
    "temporary_crown",
    "core",
];
export const therapeuticActKindLabels = {
    implant: "Implant",
    implant_abutment: "Pilier implantaire",
    crown: "Couronne",
    bridge: "Bridge",
    temporary_crown: "Provisoire",
    core: "Reconstitution",
};
export const therapeuticRowDefinitions = {
    crown_incisor_canine_first_premolar: {
        label: therapeuticChoiceRowLabels.crown_incisor_canine_first_premolar,
        requiredKinds: ["crown"],
        optionalKinds: ["core", "temporary_crown"],
    },
    crown_second_premolar: {
        label: therapeuticChoiceRowLabels.crown_second_premolar,
        requiredKinds: ["crown"],
        optionalKinds: ["core", "temporary_crown"],
    },
    crown_molar: {
        label: therapeuticChoiceRowLabels.crown_molar,
        requiredKinds: ["crown"],
        optionalKinds: ["core", "temporary_crown"],
    },
    tooth_supported_bridge: {
        label: therapeuticChoiceRowLabels.tooth_supported_bridge,
        requiredKinds: ["bridge"],
        optionalKinds: ["core", "temporary_crown"],
    },
    implant_crown: {
        label: therapeuticChoiceRowLabels.implant_crown,
        requiredKinds: ["implant", "implant_abutment", "crown"],
        optionalKinds: ["temporary_crown"],
    },
};
export function createEmptyTherapeuticChoiceRowSettings() {
    return {
        crown_incisor_canine_first_premolar: [],
        crown_second_premolar: [],
        crown_molar: [],
        tooth_supported_bridge: [],
        implant_crown: [],
    };
}
export function createEmptyTherapeuticChoicesFeesSettings() {
    return {
        defaultRows: createEmptyTherapeuticChoiceRowSettings(),
        networkRows: {},
    };
}
export function normalizeTherapeuticChoiceRowSettings(value) {
    return {
        ...createEmptyTherapeuticChoiceRowSettings(),
        ...value,
    };
}
export function normalizeTherapeuticChoicesFeesSettings(value) {
    if (!value) {
        return createEmptyTherapeuticChoicesFeesSettings();
    }
    const networkRows = {};
    for (const network of insuranceNetworkValues) {
        const rows = value.networkRows?.[network];
        if (!rows) {
            continue;
        }
        const normalizedRows = normalizeTherapeuticChoiceRowSettings(rows);
        networkRows[network] = {
            crown_incisor_canine_first_premolar: adaptTherapeuticChoiceRowForNetwork({
                row: normalizedRows.crown_incisor_canine_first_premolar,
                network,
            }),
            crown_second_premolar: adaptTherapeuticChoiceRowForNetwork({
                row: normalizedRows.crown_second_premolar,
                network,
            }),
            crown_molar: adaptTherapeuticChoiceRowForNetwork({
                row: normalizedRows.crown_molar,
                network,
            }),
            tooth_supported_bridge: adaptTherapeuticChoiceRowForNetwork({
                row: normalizedRows.tooth_supported_bridge,
                network,
            }),
            implant_crown: adaptTherapeuticChoiceRowForNetwork({
                row: normalizedRows.implant_crown,
                network,
            }),
        };
    }
    return {
        defaultRows: normalizeTherapeuticChoiceRowSettings(value.defaultRows),
        networkRows,
    };
}
export function isTherapeuticChoiceRowEmpty(row) {
    return row.length === 0;
}
export function getTherapeuticMaterialFamilyForActKind(kind) {
    if (kind === "crown" || kind === "bridge") {
        return "crown";
    }
    if (kind === "temporary_crown") {
        return "tempCrown";
    }
    if (kind === "implant_abutment") {
        return "implantAbutment";
    }
    if (kind === "core") {
        return "inlayCore";
    }
    return null;
}
export function getChoiceKindsForRow(rowKey) {
    const definition = therapeuticRowDefinitions[rowKey];
    return [...definition.requiredKinds, ...definition.optionalKinds];
}
export function isRequiredKindForRow(options) {
    return therapeuticRowDefinitions[options.rowKey].requiredKinds.includes(options.kind);
}
export function canKindBeAddedToRow(options) {
    return getChoiceKindsForRow(options.rowKey).includes(options.kind);
}
export function applyDefaultRowToEmptyNetworkRows(options) {
    const nextNetworkRows = { ...options.settings.networkRows };
    for (const network of options.activeNetworks) {
        const existingRows = normalizeTherapeuticChoiceRowSettings(nextNetworkRows[network]);
        if (!isTherapeuticChoiceRowEmpty(existingRows[options.rowKey])) {
            nextNetworkRows[network] = existingRows;
            continue;
        }
        nextNetworkRows[network] = {
            ...existingRows,
            [options.rowKey]: adaptTherapeuticChoiceRowForNetwork({
                row: options.settings.defaultRows[options.rowKey],
                network,
            }),
        };
    }
    return {
        ...options.settings,
        networkRows: nextNetworkRows,
    };
}
export function adaptTherapeuticChoiceRowForNetwork(options) {
    return options.row.map((combination) => ({
        ...combination,
        acts: combination.acts.map((act) => {
            const family = getTherapeuticMaterialFamilyForActKind(act.kind);
            if (!family || act.materialCode === null) {
                return act;
            }
            return {
                ...act,
                materialCode: isTherapeuticMaterialCodeAllowed({
                    family,
                    network: options.network,
                    materialCode: act.materialCode,
                })
                    ? act.materialCode
                    : null,
            };
        }),
    }));
}
//# sourceMappingURL=TherapeuticChoicesFees.js.map